/**
 * Function to convert jquery Ajax style configuration to work with Vanilla JS fetch()
 * To see parameters for settings accepts, see: http://api.jquery.com/jquery.ajax/
 * @param settings
 * @return Promise<Response>
 */
function ajax(settings) {
    let async = true;
    let method = 'method' in settings ? settings.method : 'POST';

    if (!'url' in settings || typeof settings.url === 'undefined' || settings.url === null) {
        throw new Error('No url is set');
    }
    if (method !== 'GET' && (!'data' in settings || typeof settings.data === 'undefined' || settings.data === null)) {
        throw new Error('No data is set');
    }
    if (!'success' in settings || typeof settings.success === 'undefined' || settings.success === null) {
        throw new Error('No success handler is set');
    }
    if (!'error' in settings || typeof settings.error === 'undefined' || settings.error === null) {
        throw new Error('No error handler is set');
    }
    if ('async' in settings || typeof settings.async !== 'undefined' || settings.async === null) {
        async = settings.async;
    }

    let formData = settings.data instanceof FormData ? settings.data : new FormData;
    if (settings.data !== null && !(settings.data instanceof FormData)) {
        Object.keys(settings.data).forEach(data => {
            let value = settings.data[data];
            formData.append(data, value);
        });
    }

    const xhr = new XMLHttpRequest();
    return new Promise((resolve, reject) => {
        xhr.onreadystatechange = (e) => {
            if (xhr.readyState !== XMLHttpRequest.DONE) {
                return;
            }

            if ([200,201].includes(xhr.status)) {
                let data = JSON.parse(xhr.responseText);
                let result = settings.success(data);
                if (typeof result !== 'undefined') {
                    resolve(result);
                }
            } else {
                let error = JSON.parse(xhr.responseText);
                let result = settings.error(error);
                if (typeof result !== 'undefined') {
                    reject(result);
                }
            }
        };
        xhr.open(method, settings.url, async);
        xhr.send(formData);
    });
}